import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@loyalup/ui';

import s from './Integrations.module.css';

const SetupPoster = () => {
  const [t] = useTranslation();

  const POSTER_HREF = `https://joinposter.com/api/auth?application_id=${process.env.REACT_APP_POSTER_APP_ID}&redirect_uri=${process.env.REACT_APP_POSTER_REDIRECT_URL}&response_type=code`;

  return (
    <>
      <h2 className={s.title}>{t('Подключение Poster')}</h2>
      <p className={s.description}>
        {t(
          'Мы разработали интеграционный плагин, который обеспечивает работу карт лояльности на базе процессинга Poster, где происходит обработка всех операций.',
        )}
      </p>
      <a href={POSTER_HREF} className={s.singleButton}>
        <Button fixedWidth={200} center>
          {t('Подключить')}
        </Button>
      </a>
    </>
  );
};

export default SetupPoster;
